import { BrokersCoverageAuditLogReason } from 'utils/web_api.schemas'

/**
 * Converts a coverage audit log reason enum value to a human-readable label
 */
function formatReasonLabel (reason: string): string {
  switch (reason) {
    case BrokersCoverageAuditLogReason.unknown:
      return 'Unknown'
    case BrokersCoverageAuditLogReason.qualifying_life_event:
      return 'Qualifying Life Event'
    case BrokersCoverageAuditLogReason.initial_ichra_invite:
      return 'Initial ICHRA Invite'
    case BrokersCoverageAuditLogReason.open_enrollment:
      return 'Open Enrollment'
    case BrokersCoverageAuditLogReason.administrative_correction:
      return 'Administrative Correction'
    case BrokersCoverageAuditLogReason.termination:
      return 'Termination'
    case BrokersCoverageAuditLogReason.member_initiated_change:
      return 'Member Initiated Change'
    default:
      // Fallback: convert snake_case to Title Case
      return reason
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
  }
}

const reasonsToSkip: BrokersCoverageAuditLogReason[] = [
  BrokersCoverageAuditLogReason.thatch_processing,
]

/**
 * Auto-generates the list of coverage audit reasons with their human-readable labels.
 * This is automatically synced with the Rails enum via the generated TypeScript types.
 * "Unknown" reason is moved to the end of the list.
 */
export function getDropdownCoverageAuditReasons () {
  const allReasons = Object.values(BrokersCoverageAuditLogReason)
    .filter(reason => !reasonsToSkip.includes(reason))
    .map(reason => ({
      value: reason,
      label: formatReasonLabel(reason),
    }))

  // Move "Unknown" to the end
  const unknownIndex = allReasons.findIndex(reason => reason.value === BrokersCoverageAuditLogReason.unknown)
  if (unknownIndex !== -1) {
    const unknownReason = allReasons.splice(unknownIndex, 1)[0]
    allReasons.push(unknownReason)
  }

  return allReasons
}
